import script from "./GalaxiesList.vue?vue&type=script&setup=true&lang=js"
export * from "./GalaxiesList.vue?vue&type=script&setup=true&lang=js"

import "./GalaxiesList.vue?vue&type=style&index=0&id=10ce2c0a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-10ce2c0a"]])

export default __exports__